import { useState } from "react";

export const useTable = ({ initialLimit = 100 }) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(initialLimit);
  const [search, setSearch] = useState("");

  return {
    page,
    limit,
    search,
    setPage,
    setLimit,
    setSearch,
  };
};
